import React, { useCallback, useMemo } from "react";
import { Container, Typography } from "ct-design";
import NoRatings from "icons/noRatings.svg";
// import NoData from "src/components/NoData";
// import { NO_RATINGS_AND_REVIEWS_DATA } from "src/constants/results";
// import { ReactComponent as NoRatingsIC } from "src/icons/chart/no_reviews.svg";
// import { ReactComponent as StarIC } from "src/icons/chart/star.svg";
// import { intToString } from "src/utils/uiHelper";

import Star from "icons/starFilled.svg";
import { formatNumberInK } from "src/utils/uiHelpers";
import NoData from "components/NoData";

export interface reviewProps {
  rating?: number;
  ratingCount?: number;
  ratingData?: { label?: string; rating?: number }[];
  breakUp?: Record<string, number>;
}

const Rating: React.FC<{ data: reviewProps | undefined }> = (props) => {
  const { data: review } = props;
  const { rating, ratingCount, breakUp } = { ...review };

  const ratingLine = useCallback(
    (ratingCount: number) => {
      const maxRating = Math.max(
        ...Object.values(breakUp as Record<string, number>)
      );
      const ratingCountWidth = (ratingCount / maxRating) * 100;
      const barStyle = {
        width: `${ratingCountWidth}%`,
        borderRadius: "20px",
      };
      return (
        <Container
          css={{
            background: "#e7e7e7",
            width: "calc(100% - 8px)",
            borderRadius: "20px",
          }}
        >
          <div style={barStyle} className="h-1 br-20 bg-neutral-900">
            <span className="bg-neutral-900"></span>
          </div>
        </Container>
      );
    },
    [breakUp]
  );

  const ratingsUI = useMemo(
    () => (
      <Container className="mt-6 mx-4 flex flex middle">
        <Typography variant="HM4"></Typography>
        <Container className="flex flex-middle">
          <Typography className="flex flex-middle" variant="HM2">
            <span className="fs-20 mb-1 mr-1">{"★"}</span>
            {"  "}
            {rating}/5 {`·`} {`${ratingCount} ratings`}
          </Typography>
        </Container>
      </Container>
    ),
    [rating, ratingCount]
  );

  const reviewsUI = useMemo(
    () => (
      <Container className="px-4 mt-6">
        {breakUp &&
          Object.keys(breakUp)
            .reverse()
            .map((key) => (
              <div key={key} className="flex flex-middle mb-3">
                <div className="flex flex-middle flex-between mr-4 lh-16">
                  <span className="fs-14">{key}</span>
                  <span>
                    <Star />
                  </span>
                </div>
                <div className="flex flex-middle w-100p  mr-4">
                  {ratingLine(breakUp[key])}
                </div>
                <Container
                  css={{
                    textAlign: "end",
                    width: "32px",
                  }}
                >
                  {formatNumberInK(breakUp[key])}
                </Container>
              </div>
            ))}
      </Container>
    ),
    [breakUp, ratingLine]
  );

  return (
    <>
      <Container className="w-40p">
        {review ? (
          <>
            {ratingCount ? ratingsUI : null}
            {breakUp ? reviewsUI : null}
          </>
        ) : (
          <NoData title="No ratings yet" Icon={<NoRatings />} showTitle />
        )}
      </Container>
    </>
  );
};
export default Rating;
